// projects/humanresources-payroll/src/assets/i18n/*/hr-pay-wage-management-card.json
export class HrPayWageManagementCardKey {
    private static readonly keyPrefix = 'hrPayWageManageCard';
    public static commonPaymentPageHeader = `${HrPayWageManagementCardKey.keyPrefix}.commonPaymentPageHeader`;
    public static individualPaymentPageHeader = `${HrPayWageManagementCardKey.keyPrefix}.individualPaymentPageHeader`;
    public static additionalPaymentPageHeader = `${HrPayWageManagementCardKey.keyPrefix}.additionalPaymentPageHeader`;
    public static wageTypeNotFoundError = `${HrPayWageManagementCardKey.keyPrefix}.wageTypeNotFoundError`;
    public static deductionPageHeader = `${HrPayWageManagementCardKey.keyPrefix}.deductionPageHeader`;
    public static pageHeader = `${HrPayWageManagementCardKey.keyPrefix}.pageHeader`;
}
